import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { EMPTY_OBJECT, NOTIFICATION_TYPE } from '../../../../constants/common'
import { SIZE } from '../../../../constants/size'
import { preventDefault } from '../../../../utils/events'
import {
  FormBody,
  FormFieldsContainer,
  FormInlineNotifications,
  useFormValidationErrorsNotification,
} from '../../../Form'
import { Content } from '../../../Modal'
import {
  BUILDING_GROUP_FORM_FIELD_MANAGERS_MAX_LENGTH,
  BUILDING_GROUP_FORM_FIELD_NAME_MANAGERS,
  NOTIFICATION_MAX_RESPONSIBLE_MANAGERS,
} from '../BuildingGroupForm.constants'
import { checkBuildingGroupFormForEmptyRequired } from '../BuildingGroupForm.utils'

import { BuildingsField } from './BuildingsField'
import { useResetUpdateManagerCheckbox } from './FormFields.hooks'
import { ManagersField } from './ManagersField'
import { TitleField } from './TitleField'

import * as styles from './FormFields.module.css'

function FormFields({
  ContentComponent = Content,
  contentComponentProps: {
    size: contentSize = SIZE.X_LARGE,
    ...contentComponentProps
  } = EMPTY_OBJECT,
  notifications,
  onCancel,
  onRemoveNotification,
  onSetNotification,
}) {
  const { dirty, isSubmitting, validateForm, values } = useFormikContext()

  const { t } = useTranslation()

  // Side effect to reset update manager checkbox
  // If responsible managers length === 0
  useResetUpdateManagerCheckbox()

  useFormValidationErrorsNotification({
    checkFormikFormEmptyRequired: checkBuildingGroupFormForEmptyRequired,
    onRemoveNotification,
    onSetNotification,
  })

  function handleCancel() {
    onCancel({ dirty })
  }

  // eslint-disable-next-line no-unused-vars -- staged for next iteration (manager-limit guard wired via onClick below)
  function handleCheckOnSubmit(event) {
    // TODO Replace check into form validator and raise error there (example is in Request/RequestForm/RequestForm.utils.js)
    if (
      values[BUILDING_GROUP_FORM_FIELD_NAME_MANAGERS].length >
      BUILDING_GROUP_FORM_FIELD_MANAGERS_MAX_LENGTH
    ) {
      preventDefault(event)

      onSetNotification({
        id: NOTIFICATION_MAX_RESPONSIBLE_MANAGERS,
        text: t('BuildingGroup.ResponsibleManagersLimitErrorNotificationKey', {
          count: NOTIFICATION_MAX_RESPONSIBLE_MANAGERS,
        }),
        type: NOTIFICATION_TYPE.error,
      })
      validateForm()
    } else {
      onRemoveNotification(NOTIFICATION_MAX_RESPONSIBLE_MANAGERS)
    }
  }

  return (
    <FormBody
      actionsProps={{
        ButtonAdd: false,
        ButtonClear: false,
        UploadComponent: false,
        cancelProps: {
          onClick: handleCancel,
        },
        className: styles.actions,
        isSubmitting,
        submitProps: {
          isLoading: isSubmitting,
          //  onClick: handleCheckOnSubmit, for next iteration
        },
      }}
    >
      <ContentComponent {...contentComponentProps} size={contentSize}>
        <FormInlineNotifications notifications={notifications} />
        <FormFieldsContainer className={styles.fieldsContainer}>
          <TitleField />
          <BuildingsField />
          <ManagersField />
        </FormFieldsContainer>
      </ContentComponent>
    </FormBody>
  )
}

export default FormFields
